import React from 'react';

export default function Servicemap(){
    return(
        <div className='servicemap-container'>
        <img src="servicemap.png"/>
        </div>
    );
}